/**
 * @file accordion.js
 */
(function ($, Drupal, once) {
  "use strict";

  Drupal.behaviors.kodakAccordion = {
    attach: function (context, settings) {
      once('kodakAccordion', document.querySelectorAll('.paragraph--type--accordion'), context).forEach((accordion) => {
        const accordionButtons = accordion.querySelectorAll(".accordion button");

        accordionButtons.forEach((button) => {
          button.addEventListener("click", function () {
            const expanded =
              button.getAttribute("aria-expanded") === "true" || false;

            // Toggle this button
            button.setAttribute("aria-expanded", !expanded);
            document.getElementById(button.getAttribute("aria-controls")).hidden =
              expanded;
          });
        });
      });


    },
  };
})(jQuery, Drupal, once);
